import { render } from "./Administration.vue?vue&type=template&id=0aa192cc&ts=true"
import script from "./Administration.vue?vue&type=script&lang=ts"
export * from "./Administration.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__